"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _gsap = require("gsap");

var _reactTransitionGroup = require("react-transition-group");

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _easing = _interopRequireDefault(require("../easing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  alwaysShowInDom: _propTypes.bool,
  children: _propTypes.node,
  easing: (0, _propTypes.arrayOf)(_propTypes.string),
  enterDuration: _propTypes.number,
  exitDuration: _propTypes.number,
  fadeInOut: _propTypes.bool,
  onEnterAnimationProperties: (0, _propTypes.objectOf)(_propTypes.any),
  onExitAnimationProperties: (0, _propTypes.objectOf)(_propTypes.any),
  show: _propTypes.bool,
  showAnimation: _propTypes.bool
};
var defaultProps = {
  alwaysShowInDom: true,
  easing: ["Power4", "easeOut"],
  enterDuration: 0.25,
  exitDuration: 0.2,
  fadeInOut: false,
  onEnterAnimationProperties: {},
  onExitAnimationProperties: {},
  showAnimation: true
};

var TransitionWidth = function TransitionWidth(_ref) {
  var alwaysShowInDom = _ref.alwaysShowInDom,
      children = _ref.children,
      easing = _ref.easing,
      enterDuration = _ref.enterDuration,
      exitDuration = _ref.exitDuration,
      fadeInOut = _ref.fadeInOut,
      onEnterAnimationProperties = _ref.onEnterAnimationProperties,
      onExitAnimationProperties = _ref.onExitAnimationProperties,
      show = _ref.show,
      showAnimation = _ref.showAnimation;
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
    appear: true,
    enter: showAnimation,
    exit: showAnimation,
    "in": showAnimation && show,
    mountOnEnter: !alwaysShowInDom,
    onEnter: function onEnter(node) {
      _gsap.TweenLite.set(node, {
        display: "inherit",
        opacity: 1,
        scaleX: 1
      });

      _gsap.TweenLite.from(node, enterDuration, Object.assign({
        ease: (0, _ramda.path)(easing, _easing["default"]),
        opacity: fadeInOut ? 0 : 1,
        scaleX: 0
      }, onEnterAnimationProperties));
    },
    onExit: function onExit(node) {
      _gsap.TweenLite.to(node, exitDuration, Object.assign({
        clearProps: alwaysShowInDom ? "all" : "none",
        ease: (0, _ramda.path)(easing, _easing["default"]),
        opacity: fadeInOut ? 0 : 1,
        scaleX: 0
      }, onExitAnimationProperties));
    },
    timeout: {
      enter: enterDuration * 1000,
      exit: exitDuration * 1000
    },
    unmountOnExit: !alwaysShowInDom
  }, children);
};

TransitionWidth.propTypes = propTypes;
TransitionWidth.defaultProps = defaultProps;
var _default = TransitionWidth;
exports["default"] = _default;